module.exports = __webpack_public_path__ + "static/media/10.a5c241d5.jpg";